// Name formats older builds stored as assignee filter values; only read to migrate saved URLs/views.
const HONORIFICS = new Set(['dr', 'mr', 'ms', 'mrs', 'prof', 'rev', 'fr']);
const SUFFIXES = new Set(['jr', 'sr', 'ii', 'iii', 'iv']);
const SHORT_NAME_CAP = 9;

const strip = (token: string) => token.replace(/\.$/, '').toLowerCase();

// "Dr. Sarah Williams" → "Dr. Sarah W.": the honorific kept, last initial uppercased.
function titledShortName(fullname: string): string {
    const parts = fullname.trim().split(/\s+/);
    const hasTitle = parts.length > 0 && HONORIFICS.has(strip(parts[0]));
    const prefix = hasTitle ? `${parts[0]} ` : '';
    const rest = hasTitle ? parts.slice(1) : parts;
    const trimmed =
        rest.length > 0 && SUFFIXES.has(strip(rest[rest.length - 1])) ? rest.slice(0, -1) : rest;
    const effective = trimmed.length > 0 ? trimmed : rest;
    if (effective.length === 0) return parts[0] ?? '';
    if (effective.length < 2) return `${prefix}${effective[0]}`;
    return `${prefix}${effective[0]} ${effective[effective.length - 1][0]?.toUpperCase()}.`;
}

// "Alexandra Smith" → "Alexan S.": capped at 9 characters.
function cappedShortName(fullname: string): string {
    const parts = fullname.trim().split(/\s+/);
    if (parts.length < 2) return parts[0].slice(0, SHORT_NAME_CAP);
    const first = parts[0];
    const lastInitial = parts[parts.length - 1][0]?.toUpperCase();
    const candidate = `${first} ${lastInitial}.`;
    return candidate.length > SHORT_NAME_CAP
        ? `${first.slice(0, SHORT_NAME_CAP - 3)} ${lastInitial}.`
        : candidate;
}

export function legacyAssigneeLabels(fullname: string): string[] {
    return [titledShortName(fullname), cappedShortName(fullname)];
}
